import Api from './api.service';

const ENDPOINT = 'financial';

export default {
  getDoctors: (params = {}) => Api.get(`${ENDPOINT}/list-active-doctors-in-month`,{ params }),
  getTransactions: (params = {}) => Api.get(`${ENDPOINT}/get-financial-closing`, { params }),
};
